import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function rejectDocuments(payload) {
  try {
    const url = paths.rejectDocuments(); 
    const response = await axiosInstance.post(url, payload); 
    return response.data; 
  } catch (error) {
    return Promise.reject(error);
  }
}

const useRejectDocuments = () => {
  return useMutation({
    mutationFn: rejectDocuments, 
  });
};

export { useRejectDocuments };